export var CampaignSearchStatus;
(function (CampaignSearchStatus) {
    CampaignSearchStatus["ACTIVE"] = "ACTIVE";
    CampaignSearchStatus["BOOKED"] = "BOOKED";
    CampaignSearchStatus["EXPIRED"] = "EXPIRED";
    CampaignSearchStatus["EXHAUSTED"] = "EXHAUSTED";
    CampaignSearchStatus["STOPPED"] = "STOPPED";
})(CampaignSearchStatus || (CampaignSearchStatus = {}));
